import axios from 'axios';

import ajaxer from '../../../ajax';
import buildApiUrl from '../../../build-api-url';
import formatOfficeHolder from '../../../format-officeholder';
import {
  POLITICIAN_BASE,
  POLITICIAN_FIELDS,
  OFFICEHOLDER_BASE,
} from '../../../constants';

import {
  IApiResponse,
  IApiOfficeholder,
  IOfficeholder,
  IApiPolitician,
  EApiFilter,
  EGovBodyFilter,
} from '../../../types';
import { IFetcherResponse } from '../types';

function getTagIds(officeholders: IOfficeholder[]): string[] {
  const tagIds = officeholders.map(({ identifiers }) => {
    if (!identifiers.length) {
      return '';
    }

    const guten = identifiers.filter(
      identifier => identifier.scheme === 'guten-tags'
    );

    if (!guten.length) {
      return '';
    }
    return guten[0].identifier;
  });

  return tagIds.filter(tagId => !!tagId);
}

export default function createFetcher(body: EGovBodyFilter) {
  return async (): Promise<IFetcherResponse> => {
    // https://republic.texastribune.org/api/v1/officeholders/?body={BODY}&cycle={YEAR}&is_active=true&limit=1000
    const officeholdersUrl = `${OFFICEHOLDER_BASE}${body}.json`;

    const {
      data: { results: officeholderResults },
    } = await axios.get<IApiResponse<IApiOfficeholder>>(officeholdersUrl);

    const officeholders = officeholderResults.map(officeholder =>
      formatOfficeHolder(officeholder)
    );

    const politiciansUrl = buildApiUrl({
      url: POLITICIAN_BASE,
      filters: [
        {
          name: EApiFilter.Id,
          items: [{ value: getTagIds(officeholders).join(), include: true }],
        },
        {
          name: EApiFilter.Limit,
          items: [{ value: '1000', include: true }],
        },
      ],
      fields: POLITICIAN_FIELDS,
    });

    const {
      data: { results: politicians },
    } = await ajaxer.get<IApiResponse<IApiPolitician>>(politiciansUrl);

    return { politicians, officeholders };
  };
}
